import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import GoalsActions from '../actions/goals.actions';
import ReportsActions from '../actions/reports.actions';

export function* createClientGoalForBonusRequest(api, action) {
  const { clientId, payload } = action;
  const response = yield api.createClientGoalForBonus(clientId, payload);
  if (response && response.ok) {
    InsighttNotification('success', `Goal for Bonus for ${payload.clientName} was created successfully`, response);
    yield put(ReportsActions.createClientGoalForBonusSuccess(response.data));
    yield put(GoalsActions.createClientGoalForBonusSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to create Goal for Bonus', response);
    yield put(GoalsActions.createClientGoalForBonusFailure(clientId));
  }
}

export function* updateClientGoalForBonusRequest(api, action) {
  const { clientId, goalId, payload } = action;
  const response = yield api.updateClientGoalForBonus(clientId, goalId, payload);
  if (response && response.ok) {
    InsighttNotification('success', `Goal for Bonus for ${payload.clientName} was updated successfully`, response);
    yield put(ReportsActions.updateClientGoalForBonusSuccess(response.data));
    yield put(GoalsActions.updateClientGoalForBonusSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to update Goal for Bous', response);
    yield put(GoalsActions.updateClientGoalForBonusFailure(clientId));
  }
}

export function* getMTDYTDClientRRGoalsRequest(api, action) {
  const { clientId, timezoneOffset } = action;
  const response = yield api.getMTDYTDClientRRGoals(clientId, timezoneOffset);
  if (response && response.ok) {
    yield put(GoalsActions.getMTDYTDClientRRGoalsSuccess(response.data));
  } else {
    yield put(GoalsActions.getMTDYTDClientRRGoalsFailure());
  }
}
